<template>
  <div class="app-main-inner ai-task-create">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="left"
      size="mini"
      class="section task-form"
    >
      <el-row :gutter="12">
        <el-col :span="24">
          <div class="section-title">
            <div class="section-title__bar" />
            <div>
              <div class="section-title__main">新建对账任务</div>
              <div class="section-title__desc">填写基础信息并上传供应商账单后发起对账任务。</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item label="选择供应商" required>
            <el-select
              v-model="form.supplierId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入供应商名称搜索"
              style="width: 320px;"
              :remote-method="remoteSupplierMethod"
              :loading="supplierLoading"
              @change="handleSupplierChange"
            >
              <el-option
                v-for="item in supplierOptions"
                :key="item.supplierId"
                :label="item.supplierName"
                :value="item.supplierId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item label="开始日期" required>
            <el-date-picker
              v-model="form.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择开始日期"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结束日期" required>
            <el-date-picker
              v-model="form.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择结束日期"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item label="账单类型" required>
            <el-radio-group v-model="form.billType" class="bill-type-group">
              <el-radio-button
                v-for="item in billTypeOptions"
                :key="item.code"
                :label="item.code"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item label="上传账单" required>
            <el-upload
              ref="upload"
              drag
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :multiple="false"
              accept=".xlsx,.xls"
              :on-change="handleUploadChange"
              class="upload-area"
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text">点击或拖拽到此处上传</div>
              <div class="el-upload__tip">只支持 Excel 文件（.xlsx、.xls）</div>
            </el-upload>
            <div v-if="uploading" class="upload-result">
              <span>正在上传...</span>
            </div>
            <div v-else-if="form.fileName" class="upload-result">
              <span>当前文件：{{ form.fileName }}</span>
              <el-button type="text" size="mini" @click="clearFile">移除</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="请输入备注说明"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="24">
          <el-form-item label-width="0" class="form-actions">
            <el-button type="primary" size="mini" :loading="submitting" @click="handleSubmit">提交创建</el-button>
            <el-button size="mini" :disabled="submitting" @click="$emit('back')">取消</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { searchSuppliers, uploadBillFile, createReconTask } from '@/api/clearing/aiReconciliation'

export default {
  name: 'TabAiMatch',
  data() {
    return {
      supplierOptions: [],
      supplierLoading: false,
      supplierSelected: null,
      uploading: false,
      submitting: false,
      billTypeOptions: [
        { code: 'FLEET', label: '干线费用' },
        { code: 'BOOKING', label: '订舱费用' },
        { code: 'CUSTOMS', label: '报关费用' },
        { code: 'FBA', label: '仓储费用' },
        { code: 'OVERSEAS_FLEET', label: '海外尾程' },
        { code: 'OTHER', label: '其他费用' }
      ],
      form: {
        supplierId: '',
        supplierName: '',
        startDate: '',
        endDate: '',
        billType: '',
        fileName: '',
        fileId: '',
        fileSha256: '',
        remark: ''
      }
    }
  },
  created() {
    this.remoteSupplierMethod('')
  },
  methods: {
    remoteSupplierMethod(query) {
      if (this.supplierTimer) {
        clearTimeout(this.supplierTimer)
      }
      this.supplierTimer = setTimeout(() => {
        this.supplierLoading = true
        searchSuppliers({ likeName: query || null, pageSize: 100 })
          .then(res => {
            const list = (res && res.data) || []
            // 保留已选中项，避免远程搜索覆盖后选中 label 丢失
            if (this.supplierSelected && !list.find(i => i.supplierId === this.supplierSelected.supplierId)) {
              list.unshift(this.supplierSelected)
            }
            this.supplierOptions = list
          })
          .catch(() => {
            this.supplierOptions = []
          })
          .finally(() => {
            this.supplierLoading = false
          })
      }, 300)
    },
    handleSupplierChange(val) {
      const matched = this.supplierOptions.find(item => item.supplierId === val)
      this.supplierSelected = matched || null
      this.form.supplierName = matched ? matched.supplierName : ''
    },
    handleUploadChange(file) {
      // 只支持 Excel
      const ext = file.name.split('.').pop().toLowerCase()
      if (!['xlsx', 'xls'].includes(ext)) {
        this.$message.warning('只支持 .xlsx、.xls 格式的 Excel 文件')
        this.$refs.upload.clearFiles()
        return
      }

      this.uploading = true
      const formData = new FormData()
      formData.append('file', file.raw)
      uploadBillFile(formData)
        .then(res => {
          const data = (res && res.data) || {}
          this.form.fileId = data.fileId || ''
          this.form.fileSha256 = data.fileSha256 || ''
          this.form.fileName = data.fileName || file.name
          this.$message.success('文件上传成功')
        })
        .catch(() => {
          this.$message.error('文件上传失败，请重试')
          this.clearFile()
        })
        .finally(() => {
          this.uploading = false
        })
    },
    clearFile() {
      this.form.fileName = ''
      this.form.fileId = ''
      this.form.fileSha256 = ''
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    },
    handleSubmit() {
      if (!this.form.supplierId) {
        this.$message.warning('请选择供应商')
        return
      }
      if (!this.form.startDate) {
        this.$message.warning('请选择开始日期')
        return
      }
      if (!this.form.endDate) {
        this.$message.warning('请选择结束日期')
        return
      }
      if (!this.form.billType) {
        this.$message.warning('请选择账单类型')
        return
      }
      if (this.uploading) {
        this.$message.warning('文件正在上传，请稍候')
        return
      }
      if (!this.form.fileId) {
        this.$message.warning('请上传供应商账单')
        return
      }

      this.submitting = true
      const payload = {
        supplierId: this.form.supplierId,
        supplierName: this.form.supplierName,
        billType: this.form.billType,
        periodStart: this.form.startDate,
        periodEnd: this.form.endDate,
        originalFileId: this.form.fileId,
        originalFileName: this.form.fileName,
        originalFileSha256: this.form.fileSha256,
        remark: this.form.remark || null
      }
      createReconTask(payload)
        .then(res => {
          this.$message.success('对账任务创建成功')
          this.resetForm()
          this.$emit('created', res && res.data)
        })
        .catch(() => {
          this.$message.error('创建失败，请重试')
        })
        .finally(() => {
          this.submitting = false
        })
    },
    resetForm() {
      this.form = {
        supplierId: '',
        supplierName: '',
        startDate: '',
        endDate: '',
        billType: '',
        fileName: '',
        fileId: '',
        fileSha256: '',
        remark: ''
      }
      this.supplierSelected = null
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-task-create {
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 12px 16px 24px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.task-form {
  width: 100%;
}

/* 去掉 app-main-inner-row 全局类后，补回原全局表单项间距，保持视觉一致 */
::v-deep .task-form .el-form-item {
  margin-bottom: 3px;
}

::v-deep .task-form .el-col {
  margin-top: 10px;
}

.section-title {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.section-title__bar {
  width: 12px;
  height: 30px;
  margin-right: 8px;
  background-color: #57d1ff;
}

.section-title__main {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  line-height: 20px;
}

.section-title__desc {
  margin-top: 4px;
  color: #909399;
  line-height: 18px;
}

.bill-type-group {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .bill-type-group .el-radio-button {
  margin: 0 8px 8px 0;
}

::v-deep .bill-type-group .el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 3px;
}

.upload-area {
  width: 480px;
  max-width: 100%;
}

.upload-result {
  margin-top: 4px;
  color: #606266;
}

.form-actions {
  margin-top: 6px;
}
</style>
